import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTriangleGrab = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "8 6 20 20",
	stroke: "currentColor",
	fill: "white",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M19.6098 23.4555C18.8232 24.686 17.026 24.686 16.2395 23.4555L8.96657 12.0776C8.11561 10.7463 9.07171 9.00045 10.6517 9.00045L25.1975 9.00045C26.7775 9.00045 27.7336 10.7463 26.8826 12.0776L19.6098 23.4555Z" }) }),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.2583 12.5V17",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.2583 12.5V17",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgTriangleGrab;
